import { useTranslation } from 'react-i18next';

import theBeginningsImg from '@/assets/whoWeAre_beginnings.jpg';
import ourMissionImg from '@/assets/whoWeAre_ourMission.png';
import ourVisionImg from '@/assets/whoWeAre_ourVision.png';

export const HistoryAndMissionSection = () => {
  const { t } = useTranslation('whoWeAre');

  return (
    <div className="section bg-dark text-white rounded-lg">
      <div className="flex flex-col items-center gap-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-4/6">
          <div>
            <div className="md:sticky top-0 self-start section-title2 !text-white py-8 blur-bottom-dark">
              {t('beginningsTitle')}
            </div>
            <div className="section-content !text-white">{t('beginningsDescription')}</div>
          </div>
          <div className="flex justify-center items-center">
            <img
              src={theBeginningsImg}
              alt={t('beginningsTitle')}
              className="rounded-lg z-10"
              loading="lazy"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-4/6">
          <div className="flex justify-center items-center">
            <img
              src={ourMissionImg}
              alt={t('missionTitle')}
              className="rounded-lg z-10"
              loading="lazy"
            />
          </div>
          <div>
            <div className="md:sticky top-0 self-start bg-dark section-title2 !text-white py-8 blur-bottom-dark">
              {t('missionTitle')}
            </div>
            <div className="section-content !text-white">{t('missionDescription')}</div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:w-4/6">
          <div>
            <div className="md:sticky top-0 self-start bg-dark section-title2 !text-white py-8 blur-bottom-dark">
              {t('visionTitle')}
            </div>
            <div className="section-content !text-white">{t('visionDescription')}</div>
          </div>
          <div className="flex justify-center items-center">
            <img
              src={ourVisionImg}
              alt={t('visionTitle')}
              className="rounded-lg z-10"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
